/**
 * Centralized API path constants.
 * Never hardcode paths in hooks — always reference from here.
 */
export const ENDPOINTS = {
  // Health
  health: "/api/v1/health",

  // Lineage
  lineageNodes: "/api/v1/lineage/nodes",
  lineageEdges: "/api/v1/lineage/edges",
  traverseForward: "/api/v1/lineage/traverse/forward",
  traverseReverse: "/api/v1/lineage/traverse/reverse",
  dataSubjectSearch: "/api/v1/lineage/data-subjects/search",

  // Audit
  auditEvents: "/api/v1/audit/events",
  auditChainVerify: "/api/v1/audit/verify",
  auditExport: "/api/v1/audit/export",

  // Reports
  reportGenerate: "/api/v1/reports/generate",
  reportGet: (id: string) => `/api/v1/reports/${id}`,
  reportDownload: (id: string) => `/api/v1/reports/${id}/download`,
  reportList: "/api/v1/reports",

  // Auth
  authLogin: "/api/v1/auth/login",
  authMe: "/api/v1/auth/me",
  apiKeys: "/api/v1/auth/api-keys",
  apiKey: (id: string) => `/api/v1/auth/api-keys/${id}`,

  // Connectors
  connectors: "/api/v1/connectors",
  connector: (id: string) => `/api/v1/connectors/${id}`,
  connectorSync: (id: string) => `/api/v1/connectors/${id}/sync`,
  connectorSyncHistory: (id: string) => `/api/v1/connectors/${id}/sync-history`,

  // Gateway
  providerKeys: "/api/v1/gateway/provider-keys",
  providerKey: (id: string) => `/api/v1/gateway/provider-keys/${id}`,
  gatewayUsage: "/api/v1/gateway/usage",

  // Alerts
  alerts: "/api/v1/alerts",
  alertAcknowledge: (id: string) => `/api/v1/alerts/${id}/acknowledge`,
  alertsWs: "/api/v1/alerts/ws",

  // Review Queue
  reviewQueue: "/api/v1/review-queue",
  reviewItem: (id: string) => `/api/v1/review-queue/${id}`,
  reviewItemApprove: (id: string) => `/api/v1/review-queue/${id}/approve`,
  reviewItemReject: (id: string) => `/api/v1/review-queue/${id}/reject`,
  reviewItemEscalate: (id: string) => `/api/v1/review-queue/${id}/escalate`,

  // Erasure
  erasureRequests: "/api/v1/lineage/data-subjects/erasure-requests",
  erasureRequestCreate: (hash: string) =>
    `/api/v1/lineage/data-subjects/${hash}/erasure-requests`,
  erasureRequest: (id: string) =>
    `/api/v1/lineage/data-subjects/erasure-requests/${id}`,
  erasureRequestExecute: (id: string) =>
    `/api/v1/lineage/data-subjects/erasure-requests/${id}/execute`,
  erasureRequestReject: (id: string) =>
    `/api/v1/lineage/data-subjects/erasure-requests/${id}/reject`,

  // Consent
  consentRecords: (hash: string) =>
    `/api/v1/lineage/data-subjects/${hash}/consent`,
  consentWithdraw: (hash: string, id: string) =>
    `/api/v1/lineage/data-subjects/${hash}/consent/${id}`,

  // Retention
  retentionPolicies: "/api/v1/retention-policies",
  retentionPolicy: (id: string) => `/api/v1/retention-policies/${id}`,
  retentionEvaluate: "/api/v1/retention-policies/evaluate",
  retentionEnforce: "/api/v1/retention-policies/enforce",
} as const;
